import { FormControl, FormControlLabel, Grid } from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomCheckbox,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  CustomTextFeildforFamily,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import styles from "../../contactUs/contactus.module.scss";
import { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import apiPath from "../../../config/apiPaths.json";
import { DietiesListByPoojaIdProps } from "../../../infrastructure/GlobalContextProvider";
import { apiRequest } from "../../../infrastructure/backendService";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import HcccTimePicker from "../../common/customTimePicker/hcccTimePicker";

const SpecialEventDonationReport = ({
  sendDataToParent,
  getReportData,
}: any) => {
  const [formData, setFormData] = useState<any>({
    // event: {id:'',description:''},
    event:'',
    eventDateFrom: dayjs().subtract(1, 'year').format("YYYY-MM-DD"),
    eventTimeFrom:dayjs().subtract(1, 'hour').format("hh:mm A"),
    eventDateTo: dayjs().format("YYYY-MM-DD"),
    eventTimeTo: dayjs().format("hh:mm A"),
    amount: "",
  });
  const [loading, setLoading] = useState(false);
  const [eventList, setEventList] = useState<DietiesListByPoojaIdProps[]>([]);
  const [mailToManager, setMailToManager] = useState<boolean>(false);
  const [mailToDevotee, setMailToDevotee] = useState<boolean>(false);
  const [eventId, setEventId] = useState<any>('');
  const [eventName, setEventName] = useState<any>('');
  const [errorMessage, setErrorMessage] = useState<any>('');
  function convertToNumberIfNumeric(id:any) {
    if (!isNaN(id) && id.trim() !== '') {
      return false;
    } else {
      return true;
    }
  }
  useEffect(() => {
    apiRequest({
      method: "GET",
      // endpoint: apiPath.purposeOfDonations,
      endpoint: "/report-dashboard/eventAndDonationPurpose",
      includeToken: true,
      params: {
        poojaId: 56,
      },
    })
      .then((res) => {
        setEventList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getSpecialEventReports = () => {
    const reqBody = {
      specialEventId: eventId,
      specialEventName: eventName,
      searchStartDate: formData.eventDateFrom,
      searchEndDate: formData.eventDateTo,
      searchAmount: formData.amount,
      mailToDevotee: mailToDevotee,
      mailToManager: mailToManager,
      donation: convertToNumberIfNumeric(eventId)
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.specialEventDonationReport,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, {reqBody,reportName:'SpecialEventDonationReport'});
          const response = res.data.map((report:any)=>{
            let counter = 1
            return {
              ...report,
              userinfo:report.userinfo.map((userInfo:any)=>{
                const familyInfo = userInfo.familymemberinfo && userInfo.familymemberinfo.value 
                ? JSON.parse(userInfo.familymemberinfo.value) 
                : [];
                return {
                  "Sr.No.":counter++,
                  "Reference Number":userInfo.receiptnumber,
                  "Donation Date":userInfo.dateofdonation,
                  "Devotee Name": `${userInfo.devoteename || '--'}
                ${familyInfo.map((info: any) => info.devoteename || '--').join('\n')
                }`,
                  Gotram:`${userInfo.gothram ? userInfo.gothram : '-'}
                          ${familyInfo.map((info:any) => info.gothram ? info.gothram : '-').join('\n')}`,
                  Nakshtram:`${userInfo.nakshtram ? userInfo.nakshtram : '-'}
                              ${familyInfo.map((info:any) => info.nakshtram ? info.nakshtram : '-').join('\n')}`,
                  "Description":`${userInfo.donationpurpose || "--"}`,
                  "Donation Amount":formatAmount(userInfo.amount),
                }
              })
            }
          })
        getReportData(response);
        // getReportData(res.data);
      })
      .catch((err) => {        
        setLoading(false);
      });
  };

  const handleSave = async (): Promise<any> => {
    if(!formData.event){
     setErrorMessage('Event / Donation Purpose is Required')
      return;
    }
    try {
      // Call your API or perform other actions here
      getSpecialEventReports();
    } catch (error) {
      setLoading(false);
    }
  };
  const handleMailToManagerDevotee = (type:string,event: any) => {
    const isChecked = event.target.checked;
    if(type === 'mailToManager'){
      setMailToManager(isChecked);
    }else{
      setMailToDevotee(isChecked);
    }
  };
  const handleFieldChange = (field: any, value: any) => {
    if (field === 'eventDateFrom' || field === 'eventDateTo') {
        const formattedDate = dayjs(value, 'YYYY-MM-DD');
        setFormData({
            ...formData,
            [field]: formattedDate.isValid() ? formattedDate.format('YYYY-MM-DD') : '',
        });
      } else if(field === 'event'){
          setFormData({
              ...formData,
              [field]: value,
          });
          setEventId(value.id);
          setEventName(value.description)
          setErrorMessage('')
      }else {
          setFormData({
              ...formData,
              [field]: value,
          });
      }
  };

  const EventsListDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl sx={{width:"100%"}}
          className={styles.moveToDropdown}
        >
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formData.event}
            onChange={(e) => {
              handleFieldChange("event", e.target.value);
            }}
            className={styles.textField}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {eventList.map((item: any, i: any) => (
              <CustomMenuItem value={item} key={i}>
                {item.description}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };

  const [isDatePickerFromOpen, setDatePickerFromOpen] = useState(false);
  const [isDatePickerToOpen, setDatePickeToOpen] = useState(false);

  useEffect(() => {
    setDatePickerFromOpen(false);
  }, [formData.eventDateFrom]);

  useEffect(() => {
    setDatePickeToOpen(false);
  }, [formData.eventDateTo]);

  const poojaStartDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM/DD/YYYY"
                value={
                  formData.eventDateFrom
                    ? dayjs(formData.eventDateFrom, "YYYY-MM-DD")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("eventDateFrom", value);
                }}
                className={styles.textField}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const poojaEndDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM/DD/YYYY"
                value={
                  formData.eventDateTo
                    ? dayjs(formData.eventDateTo, "YYYY-MM-DD")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("eventDateTo", value);
                }}
                className={styles.textField}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const handelClear = () => {
    setFormData({
      event: '',
      eventDateFrom: "",
      eventTimeFrom: "",
      eventDateTo: "",
      eventTimeTo: "",
      amount: "",
    });
  };

  return (
    <div className={styles.abhishekamReportsMainContainer}>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Event / Donation Purpose", true)}
          {EventsListDropdown()}
          {errorMessage &&
          <span style={{color:'#f00'}}>{errorMessage}</span>
          }
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Date From", false)}
          {poojaStartDatePicker()}
        </Grid>
        <Grid xs={12} sm={3} item>
          <HcccTimePicker
            handleFieldChange={handleFieldChange}
            labelName="Time From"
            fieldName="eventTimeFrom"
            isLabelNotRequired={true}
            className={styles.textFieldTimeBg}
            value={formData.eventTimeFrom}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Date To", false)}
          {poojaEndDatePicker()}
        </Grid>
        <Grid xs={12} sm={3} item>
          <HcccTimePicker
            handleFieldChange={handleFieldChange}
            labelName="Time To"
            fieldName="eventTimeTo"
            isLabelNotRequired={true}
            className={styles.textFieldTimeBg}
            value={formData.eventTimeTo}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Amount", false)}
          <CustomTextFeildforFamily
            fullWidth
            required
            value={formData.amount}
            onChange={(e) => {
              handleFieldChange("amount", e.target.value);
            }}
            className={styles.textField}
          />
        </Grid>
      </Grid>
      {CustomRequiredInputLabel(
        "Result Should be In >= Your Enter Amount.",
        false
      )}
      <Grid xs={12} item sx={{ display: "flex", gap: "16px" }}>
        <FormControlLabel
          control={
            <CustomCheckbox
              checked={mailToManager}
              onChange={(event)=>handleMailToManagerDevotee('mailToManager',event)}
            />
          }
          label="Send Report to Manager/Religious Chair"
          sx={{
            color: "#000",
            fontSize: "16px",
          }}
        />
      </Grid>
      <Grid xs={12} item sx={{ display: "flex", gap: "16px" }}>
        <FormControlLabel
          control={
            <CustomCheckbox
              checked={mailToDevotee}
              onChange={(event)=>handleMailToManagerDevotee('mailToDevotee',event)}
            />
          }
          label="Send an email to devotees"
          sx={{
            color: "#000",
            fontSize: "16px",
          }}
        />
      </Grid>
      <Grid
        xs={12}
        item
        sx={{ marginTop: "16px", display: "flex", gap: "16px" }}
      >
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handleSave}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handelClear}>Reset</CommonOutlinedButton>
      </Grid>
    </div>
  );
};

export default SpecialEventDonationReport;
